import { render, staticRenderFns } from "./PopForgetPassword.vue?vue&type=template&id=0da14cfe&lang=pug"
import script from "./PopForgetPassword.vue?vue&type=script&lang=js"
export * from "./PopForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./PopForgetPassword.vue?vue&type=style&index=0&id=0da14cfe&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports